import { format, differenceInCalendarDays as differenceInCalendarDaysFNS, addMinutes, subMinutes } from "date-fns";
import { getOffset, toDate } from "../TimeZoneHelper";
/**
 * Wrapper around Date-Fns so Public/Secure Integration don't need to import date-fns
 *
 * @param {date} date
 * @param {object} options
 */

export var formatSimpleDate = function formatSimpleDate(date) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$pattern = options.pattern,
      pattern = _options$pattern === void 0 ? "DD/MM/YYYY" : _options$pattern;
  return format(date, pattern, {
    convertTimeZone: false
  });
};
export var formatDate = function formatDate(dateValue, profile, config) {
  var defaultDateFormat = "Do MMMM, YYYY";

  if (!dateValue) {
    return "";
  }

  if (profile && config) {
    config.map(function (item) {
      if (profile.country === item.countryCode && profile.language === item.languageCode) {
        defaultDateFormat = item.dateFormat;
      }
    });
  }

  return "".concat(format(dateValue, defaultDateFormat));
};
export var differenceInCalendarDays = function differenceInCalendarDays(leftDate, rightDate) {
  return differenceInCalendarDaysFNS(leftDate, rightDate);
};
/**
 * Returns the time in MS according to the given timzone
 *
 * All these Debug's are for LD-1098 Chrome 77 issue!
 *
 * @param {Date} date
 * @param {object} timeZone
 */

export var getDateForTimeZone = function getDateForTimeZone(inputDate) {
  var timeZone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var log = {
    debug: function debug() {} //a => console.warn(a) //eslint-disable-line

  }; //default to UTC in case there is not timezone specified

  var _timeZone$value = timeZone.value,
      value = _timeZone$value === void 0 ? "UTC" : _timeZone$value; //handles string date and number ms date

  var date = toDate(inputDate);
  log.debug(timeZone);
  log.debug(Math.abs(date.getTimezoneOffset())); //firstly convert the input date to UTC as date object come backed with user timezone

  var utcDate = adjustDateToUTC(date);
  log.debug(utcDate.getTime()); //find out how many minutes we are away from UTC for the target timezone

  try {
    var offsetInMinutes = getOffset(value, utcDate);
    log.debug("offset ".concat(offsetInMinutes)); //the zonedDate is the data adjusted to the users desired timezone

    var zonedDate = adjustDate(utcDate, offsetInMinutes);
    log.debug(zonedDate);
    log.debug(zonedDate.getTime());
    return zonedDate;
  } catch (error) {
    console.warn("Failed to localise time "); //eslint-disable-line

    return utcDate;
  }
};

var adjustDateToUTC = function adjustDateToUTC(date, offset) {
  var offsetInMinutes = offset ? offset : date.getTimezoneOffset();
  var utcDate = null;

  if (Math.sign(offsetInMinutes) === -1) {
    utcDate = addMinutes(date, Math.abs(offsetInMinutes));
  } else {
    utcDate = subMinutes(date, offsetInMinutes);
  }

  return utcDate;
};

var adjustDate = function adjustDate(date, offsetInMinutes) {
  var adjustedDate = null; //if negative, subtract minutes

  if (Math.sign(offsetInMinutes) === -1) {
    //Math.abs convert negative to positive
    adjustedDate = subMinutes(date, Math.abs(offsetInMinutes));
  } else {
    adjustedDate = addMinutes(date, offsetInMinutes);
  }

  return adjustedDate;
};
/**
 * Formats a date taking into account a desired timezone
 *
 * @param {date|string} inputDate
 * @param {string} formatString
 * @param {object} timeZone
 */


export var formatToTimeZone = function formatToTimeZone(inputDate, formatString) {
  var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _timeZone$value2 = timeZone.value,
      value = _timeZone$value2 === void 0 ? "UTC" : _timeZone$value2; //handles string date and number ms date

  var date = toDate(inputDate);
  var offsetInMinutes = getOffset(value, new Date()); //the zonedDate is the data adjusted to the users desired timezone

  var zonedDate = date; //if the offset === 0 i.e. they want to see UTC, show

  if (offsetInMinutes !== 0) {
    zonedDate = adjustDateToUTC(date, offsetInMinutes);
  }

  return formatSimpleDate(getUTCDate(zonedDate), {
    pattern: formatString
  });
};

var getUTCDate = function getUTCDate() {
  var dateString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  var date = new Date(dateString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
};